export const PDF_ORIENTATION = {
  PORTRAIT: 'portrait', // 세로
  LANDSCAPE: 'landscape', // 가로
} as const;

export const PDF_SIZE_PORTRAIT = {
  A4: {
    WIDTH: 210,
    HEIGHT: 297,
  },
};

export const PDF_SIZE_LANDSCAPE = {
  A4: {
    WIDTH: 297,
    HEIGHT: 210,
  },
};
